export default __webpack_public_path__ + "static/media/sanmar12.26cc869b.jpg";